import React, { ChangeEvent, useMemo } from 'react';
import { Grid } from '@mui/material';
import { getIn } from 'formik';
import moment from 'moment-timezone';

import { InputComponent } from '../inputComponents/InputComponent';
import { DateTimePicker } from '../selectComponents/DateTimePicker';
import { createDateRestrictions } from '../../utils/dateUtils';

interface DynamicVoucherSectionProps {
    formik: any;
    onToggleVoucherGeneration: (e: ChangeEvent<HTMLInputElement>) => void;
}

const DynamicVoucherSection: React.FC<DynamicVoucherSectionProps> = ({
    formik,
    onToggleVoucherGeneration,
}) => {
    const showDynamicFields = formik.values.dynamic_gen === 'true';

    const { minDate, maxDate } = useMemo(() => {
        const prizeStatus = formik?.values?.tempParams?.prizeStatus;

        if (prizeStatus === 'custom') {
            return createDateRestrictions(formik?.values?.tempParams?.start_date, formik?.values?.tempParams?.end_date);
        } else if (prizeStatus === 'active' || prizeStatus === 'inactive') {
            return createDateRestrictions(new Date().toISOString(), formik?.values?.end_date); 
        }

    }, [
        formik?.values?.tempParams?.prizeStatus,
        formik?.values?.tempParams?.start_date,
        formik?.values?.tempParams?.end_date,
        formik?.values?.end_date
    ]);

    const handleExpirationChange = (val: any) => {
        const selected = moment.utc(val);
        formik.setFieldTouched('dynamic_expiry', true, false);
        formik.setFieldValue('dynamic_expiry', selected.toISOString());
    };

    return (
        <>
            {showDynamicFields && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DateTimePicker
                            formik={formik}
                            formikFieldName="dynamic_expiry"
                            datetimeValue={
                                formik.values.dynamic_expiry
                                    ? moment(formik.values.dynamic_expiry)
                                    : null
                            }
                            handleChange={handleExpirationChange}
                            pickerLabel="Voucher Expiration Date"
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputComponent
                            inputClassName="input-space"
                            formik={formik}
                            inputValue={getIn(formik.values, 'dynamic_prefix')}
                            formikLabel="dynamic_prefix"
                            title="Voucher Prefix"
                            titleVariant="body1"
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <InputComponent
                            inputClassName="input-space"
                            formik={formik}
                            inputValue={getIn(formik.values, 'dynamic_suffix')}
                            formikLabel="dynamic_suffix"
                            title="Voucher Suffix"
                            titleVariant="body1"
                        />
                    </Grid>
                </Grid>
            )}

        </>
    );
};

export { DynamicVoucherSection };